import React, { useCallback, useState } from 'react';

import { Autocomplete, Grid, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { SelectFieldMultiple } from '../../../../common/select_field';
import { getReservationStatusOptions } from '../../../../common/utils/reservation_utils';
import { ReservationStatusEnum } from '../../../../../core/enums/reservation/reservation';
import { getAllHubsState } from '../../../../../features/pop/get_all_hubs';
import FilterPaper from '../../../../common/filter_paper';
import { getAllProductsState } from '../../../../../features/product/get_all_products';

const ReservationFilters = ({
                                from,
                                onChangeTimeFrom,
                                to,
                                onChangeTimeTo,
                                onSelectReservationStatusesChange,
                                onSelectHubsChange,
                                onProductChange
                            }) => {
    const getAllHubs = useSelector(getAllHubsState);
    const getAllProducts = useSelector(getAllProductsState);

    const [hubIds, setHubIds] = useState([]);
    const [reservationStatuses, setReservationStatuses] = useState([ReservationStatusEnum.PAID.value, ReservationStatusEnum.PREPARED.value]);
    const [product, setProduct] = useState(null);

    const mapProductOptions = useCallback((data) => {
        return data?.map(product => ({
            key: product?.id + Math.random(),
            value: product?.id,
            label: product?.name
        }));
    }, []);

    return (
        <FilterPaper title="Filtry rezerwacji">
            <Grid container spacing={ 3 } alignItems="flex-start">

                <Grid item xs={ 12 } sm={ 6 } md={ 6 } lg={ 3 }>
                    <DatePicker
                        displayWeekNumber
                        value={ from }
                        label="Data od"
                        onChange={ newDate => onChangeTimeFrom(newDate) }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 6 } lg={ 3 }>
                    <DatePicker
                        displayWeekNumber
                        value={ to }
                        label="Data do"
                        onChange={ newDate => onChangeTimeTo(newDate) }
                        slotProps={ { textField: { size: 'small', fullWidth: true } } }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 6 } lg={ 3 }>
                    <SelectFieldMultiple
                        size="small"
                        fullWidth
                        label="Pokaż po statusie"
                        options={ getReservationStatusOptions }
                        required
                        value={ reservationStatuses }
                        onClose={ () => onSelectReservationStatusesChange(reservationStatuses) }
                        onChange={ event => setReservationStatuses(event.target.value) }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 6 } lg={ 3 }>
                    <SelectFieldMultiple
                        size="small"
                        fullWidth
                        label="Pokaż dla hubów"
                        options={ getAllHubs?.data?.map(hub => ({ value: hub?.id, label: hub?.name })) || [] }
                        required
                        value={ hubIds }
                        onClose={ () => onSelectHubsChange(hubIds) }
                        onChange={ event => setHubIds(event.target.value) }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 6 } lg={ 3 }>
                    <Autocomplete
                        options={ mapProductOptions(getAllProducts?.data) }
                        sx={ { minWidth: 400, maxWidth: 400 } }
                        value={ product }
                        size="small"
                        isOptionEqualToValue={ (option, value) => option.key === value.key }
                        onChange={ (_, value) => {
                            setProduct(value);
                            onProductChange(value === null ? '' : value?.value);
                        } }
                        renderInput={ (params) => <TextField { ...params } label="Wybierz produkt"/> }
                        renderOption={ (props, option) => (
                            <li { ...props } key={ option.key }>
                                { option.label }
                            </li>
                        ) }
                    />
                </Grid>

            </Grid>
        </FilterPaper>
    );
};

export default ReservationFilters;